import { Link, useNavigate } from 'react-router-dom';
import '../App.css';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserLayout from '../Componets/UserLayout';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import dayjs from 'dayjs'; // Import dayjs for date formatting
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ReassExams() {
  const [data, setData] = useState([]); // State to hold the API response data
  const [searchText, setSearchText] = useState(''); // State to hold the search text
  const apiUrl = process.env.REACT_APP_API_URL; // Retrieve the API URL from environment variables
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Checking if user is logged in, if not then redirect to login page
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'USER') {
      navigate('/');
    }
    // eslint-disable-next-line
  }, []);

  // Fetch data from API
  useEffect(() => {
    const token = localStorage.getItem('token');
    async function FechDataWithAxios() {
      try {
        const response = await axios.get(
          `${apiUrl}/api/answersheet/faculty/detail?allocationType=REASSESSMENT`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        );
        // console.log(response.data); // Log the response data to check the structure
        setData(response.data); // Update the state with the fetched data
      } catch (error) {
        error.response?.status === 401 && navigate('/');
        console.error('Error fetching the data', error); // Log any errors
      }
    }
    FechDataWithAxios(); // Call the function when the component mounts
  }, [apiUrl]);

  // Define a function to format the date
  const formatDate = (dateString) => {
    return dayjs(dateString).format('DD/MM/YYYY');
  };

  // Filter data based on search text
  const filteredData = data.filter(
    (item) =>
      item.examName.toLowerCase().includes(searchText.toLowerCase()) ||
      item.subjectName.toLowerCase().includes(searchText.toLowerCase())
  );

  // Define columns
  const columns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Exam Name',
      selector: (row) => row.examName,
      sortable: 'true',
    },
    {
      name: 'Subject',
      selector: (row) => row.subjectName,
    },
    {
      name: 'AnswerSheet Count',
      selector: (row) => row.answerSheetCount,
      width: '160px',
      center: 'true',
    },
    {
      name: 'Assigning Date',
      selector: (row) => formatDate(row.assignDate), // Use the formatDate function
      width: '150px',
    },
    {
      name: 'Status Counts',
      cell: (row) => (
        <div className="d-flex align-items-center ">
          <span className=" fs-6  badge rounded-pill bg-secondary text-dark ">
            {row.pendingCount}
          </span>
          <span className="  fs-6 mx-2 badge rounded-pill bg-warning text-dark ">
            {row.inProgressCount}
          </span>
          <span className="  fs-6 badge rounded-pill bg-success text-dark ">
            {row.completedCount}
          </span>
        </div>
      ),
      width: '150px',
      center: 'true',
    },
    {
      name: 'Details',
      width: '90px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            className="btn btn-secondary btn-sm "
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Start Evaluation"
            onClick={() =>
              navigate('/ReassAllocate', {
                state: {
                  id: row.examId,
                  subjectId: row.subjectId,
                  ExamName: row.examName,
                },
              })
            }
          >
            <i className="bi bi-list-columns"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <UserLayout ac3="active">
      <main id="main" className="main">
        <div className="pagetitle ">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                <Link to="/UserHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Reassessments Exams</li>
            </ol>
          </nav>
        </div>
        {/* Page */}
        <hr className="mb-0" />
        <div className="datatable-top">
          <div className="datatable-search">
            <input
              className="form-control"
              type="search"
              name="search"
              placeholder="Search"
              title="Search within table"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)} // Update search text on change
            />
          </div>
          <div className="d-flex align-items-center  mt-2  ">
            <span className="   badge rounded-pill bg-secondary   ">
              Panding
            </span>
            <span className="  mx-2 badge rounded-pill bg-warning  ">
              In Progress
            </span>
            <span className="  badge rounded-pill bg-success  ">Completed</span>
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filteredData} // Use filtered data for the table
          pagination
          className="custom-table"
          paginationPerPage={rowsPerPage} // Set rows per page
          paginationTotalRows={filteredData.length} // Total number of records
          paginationDefaultPage={currentPage} // Default starting page
          onChangePage={(page) => setCurrentPage(page)} // Update current page
          onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)} // Update rows per page
        />

        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </main>
      <Tooltip id="my-tooltip" />
    </UserLayout>
  );
}
